import React, { useState } from 'react'
import axios from 'axios'
import {
  TextField,
  Popper,
  Divider,
  Paper,
  Button,
  Drawer,
  InputAdornment,
  IconButton
} from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useDispatch } from 'react-redux'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import useStyles from './styles'
import { ReactComponent as SearchIcon } from 'static/icons/search.svg'
import { ReactComponent as AdviceIcon } from 'static/icons/advice.svg'
import { ReactComponent as LegalChangeIcon } from 'static/icons/legal-change.svg'
import history from 'browserHistory'
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded'
import Config from 'config'
import useDebouncedSearch, { SEARCH_MIN_CHARS } from 'helpers/useDebouncedSearch'


const MobileSearchOrRequestAdvice = (props) => {
  const {
    additionalRootClasses,
    additionalClasses,
    isAdmin,
    isOpen,
    setShowSearch,
    disabled
  } = props
  const localClasses = useStyles()
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [inputValue, setInputValue] = useState('')

  const handleRequestError = (error) => {
    if (error.response) {
      dispatch(checkErrorStatus(error.response.status))
    } else {
      dispatch(setSnackbar('Connection error', 'error'))
    }
    return []
  }

  const searchAdvicesAndLegalChanges = (search, cancelToken) => {
    const params = { search }
    return axios.get(`${apiUrl}search/simple-list/`, { params, cancelToken }).then(({ data }) => {
      const advicesList = (data.advices || []).map(item => ({ ...item, type: 'advice' }))
      const legalChangesList = (data.legal_changes || []).map(item => ({ ...item, type: 'legalChange' }))
      return [...advicesList, ...legalChangesList]
    }).catch(error => {
      if (axios.isCancel(error)) {
        throw error
      }
      return handleRequestError(error)
    })
  }

  const { results: advices, isLoading, searchNow } = useDebouncedSearch(
    inputValue,
    searchAdvicesAndLegalChanges,
    { enabled: isOpen && !disabled }
  )

  const handleSearchKeyDown = (event) => {
    if (event.key === 'Enter') {
      searchNow()
    }
  }

  const getNoOptionsText = () => (
    inputValue.trim().length < SEARCH_MIN_CHARS ?
      `Type at least ${SEARCH_MIN_CHARS} characters to search...` :
      'No results found'
  )


  const handleActionClick = (event) => {
    setInputValue('')
    setShowSearch(false)
    history.push(`/requests/add?name=${inputValue}`)
  }

  const handleCreateClick = (event) => {
    setInputValue('')
    setShowSearch(false)
    history.push(`/advices/add?title=${inputValue}`)
  }

  const CusomPopper = function (props) {
    return (
      <Popper {...props} className={localClasses.popper} placement='bottom-start' disablePortal>
        {props.children}
        <Divider className={localClasses.popperDivider} />
        <div className={localClasses.popperActionContainer}>
        {
          isAdmin ?
          <>
            <Button
              className={localClasses.popperAction}
              color='primary'
              onMouseDown={handleCreateClick}
              disabled={disabled}
            >
              Create an Advice
            </Button>
            <Button
              className={localClasses.popperAction}
              color='primary'
              onMouseDown={handleActionClick}
              disabled={disabled}
            >
              Request an Advice
            </Button>
          </> :
          <Button
            className={localClasses.popperAction}
            color='primary'
            onMouseDown={handleActionClick}
            disabled={disabled}
          >
            Request an Advice
          </Button>
        }
        </div>
      </Popper>
  )}

  const CustomPaper = function (props) {
    return (
     <Paper {...props} className={localClasses.paper} elevation={0} />
  )}

  const handleChange = (event, newValue) => {
    setInputValue('')
    setShowSearch(false)
    history.push(newValue.type === 'legalChange' ?
      `/legal-changes/${newValue.id}` : `/advices/${newValue.id}`)
  }

  const handleInput = (event, newInputValue, reason) => {
    if (reason === 'input') {
      setInputValue(newInputValue)
    }
  }
  return (
    <Drawer
      className={localClasses.drawer}
      open={isOpen && !disabled}
      anchor='right'
      classes={{
        paper: localClasses.drawerPaper
      }}
    >
      <Autocomplete
        openOnFocus={true}
        filterOptions={() => {return advices}}
        loading={isLoading}
        noOptionsText={getNoOptionsText()}
        clearOnEscape={true}
        open={true}
        PopperComponent={CusomPopper}
        PaperComponent={CustomPaper}
        onChange={handleChange}
        onInputChange={handleInput}
        options={advices}
        getOptionSelected={(option, value) => option.type === value.type && option.id === value.id}
        disableClearable
        getOptionLabel={(option) => option.title}
        inputValue={inputValue}
        renderOption={(option) => (
          <div className={localClasses.option}>
            {
              option.type === 'legalChange' ?
              <LegalChangeIcon className={localClasses.optionIcon} /> :
              <AdviceIcon className={localClasses.optionIcon} />
            }
            <span>{option.title}</span>
          </div>
        )}
        popupIcon={
          <SearchIcon className={localClasses.searchIcon} />
        }
        className={`${additionalClasses} ${localClasses.autocompleteRoot}`}
        renderInput={(params) => (
          <TextField
            {...params}
            autoFocus
            onKeyDown={handleSearchKeyDown}
            placeholder={isAdmin ? 'Search or Create Advice...' : 'Request or Search Advice...'}
            margin='normal'
            variant='outlined'
            InputProps={{
              ...params.InputProps,
              classes: {
                root: `${localClasses.searchRoot} ${additionalRootClasses || ''} ${localClasses.searchRootOpen}`,
                input: localClasses.searchInput,
                notchedOutline: localClasses.searchNotchedOutline
              },
              startAdornment: (
                <React.Fragment>
                  <InputAdornment position='start'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={() => setShowSearch(false)}
                    onMouseDown={() => setShowSearch(false)}
                  >
                    <ArrowBackRoundedIcon />
                  </IconButton>
                  </InputAdornment>
                </React.Fragment>
              ),
              endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color='primary' size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              )
            }}
          />
        )}
      />
    </Drawer>
  )
}

export default MobileSearchOrRequestAdvice
